'use client';

import { useQuery } from '@tanstack/react-query';
import {
  getAdminDigestDeliveryStats,
  getAdminDigestJobStats,
} from '@nomiss/services';

const DIGESTS_REFETCH_MS = 45_000;

export const DIGEST_DELIVERY_LOOKBACK_DAYS = [7, 14, 30] as const;

export type DigestDeliveryLookbackDays =
  (typeof DIGEST_DELIVERY_LOOKBACK_DAYS)[number];

export const adminDigestsQueryKeys = {
  all: ['admin', 'digests'] as const,
  jobs: () => [...adminDigestsQueryKeys.all, 'jobs'] as const,
  delivery: (days: number) =>
    [...adminDigestsQueryKeys.all, 'delivery', days] as const,
};

export function useAdminDigestJobStats(options?: { enabled?: boolean }) {
  const adminDigestJobStatsQuery = useQuery({
    queryKey: adminDigestsQueryKeys.jobs(),
    queryFn: () => getAdminDigestJobStats(),
    enabled: options?.enabled ?? true,
    refetchInterval: DIGESTS_REFETCH_MS,
  });

  return { adminDigestJobStatsQuery };
}

export function useAdminDigestDeliveryStats(
  days: DigestDeliveryLookbackDays = 7,
  options?: { enabled?: boolean },
) {
  const adminDigestDeliveryStatsQuery = useQuery({
    queryKey: adminDigestsQueryKeys.delivery(days),
    queryFn: () => getAdminDigestDeliveryStats(days),
    enabled: options?.enabled ?? true,
    refetchInterval: DIGESTS_REFETCH_MS,
  });

  return { adminDigestDeliveryStatsQuery };
}
